import { useState} from "react";
import {getAdditivesByUniqueCode} from "../../services/Administrative/additiveService";

export const useGetAdditivesByUniqueCode = () => {
    const [additive, setAdditive] = useState<any>(null);

    const fetchAdditiveByUniqueCode = async (id:number) => {
        try {
            const response:any = await getAdditivesByUniqueCode(id);
            setAdditive(response.data.additive);
        } catch (error) {
            console.error('Error fetching filters:', error);
        }
    }

    return { additive, fetchAdditiveByUniqueCode };
};
